import {Component, OnInit} from '@angular/core';
import {GamePlay} from "../../model/game-play";
import {AbstractGameComponent} from "../../game/abstract-game.component";
import { MatIcon } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-current-action',
    templateUrl: './current-action.component.html',
    styleUrls: ['./current-action.component.scss'],
    imports: [MatIcon, TranslocoModule]
})
export class CurrentActionComponent extends AbstractGameComponent implements OnInit{
  currentGamePlay!: GamePlay

  ngOnInit(): void {
    this.game.gamePlayUpdate$.subscribe(() => {
      this.updateCurrentGamePlay();
    });
    this.updateCurrentGamePlay();
  }

  private updateCurrentGamePlay(): void {
    this.currentGamePlay = this.game.getFirstPendingGamePlay();
  }
}
